import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Checkbox,
  Input,
  Label,
} from '@roger/ui-components';
import type { SizeState } from '../assessmentFormTypes';

interface SizeSectionProps {
  state: SizeState;
  onChange: (update: Partial<SizeState>) => void;
}

const SizeSection: React.FC<SizeSectionProps> = ({ state, onChange }) => (
  <AccordionItem value='size' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Size
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-2'>
        <Checkbox
          id='size-na'
          checked={state.na}
          onCheckedChange={v => onChange({ na: !!v })}
        />
        <label htmlFor='size-na' className='text-sm cursor-pointer'>
          Unable to measure (N/A)
        </label>
      </div>
      {!state.na && (
        <div className='grid grid-cols-3 gap-3'>
          {(
            [
              { label: 'Length (cm)', field: 'length' },
              { label: 'Width (cm)', field: 'width' },
              { label: 'Depth (cm)', field: 'depth' },
            ] as { label: string; field: keyof SizeState }[]
          ).map(({ label, field }) => (
            <div key={field} className='space-y-1'>
              <Label className='text-xs'>{label}</Label>
              <Input
                type='number'
                step='0.1'
                min='0'
                value={state[field] as string}
                onChange={e => onChange({ [field]: e.target.value })}
                inputSize='sm'
              />
            </div>
          ))}
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default SizeSection;
